<template>
    <div>
        <section class="content-header">
            <h1>
                История заданий
            </h1>
        </section>

        <section class="content container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <NativeTable action="publisher/getAllTasks">
                        <el-table-column prop="0" label="ID" key="ID" sortable="custom" minWidth="60px">
                            <template slot-scope="scope">
                                {{ scope.row.id }}
                            </template>
                        </el-table-column>

                        <el-table-column prop="1" label="Площадка" key="Площадка" sortable="custom" minWidth="150px">
                            <template slot-scope="scope">
                                <a target="_blank" :href="'https://vk.com/club' + scope.row.group_id">
                                  {{ scope.row.name }}
                                </a>
                            </template>
                        </el-table-column>

                        <el-table-column prop="2" label="Задача" key="Задача" sortable="custom" minWidth="130px">
                            <template slot-scope="scope">
                                {{ scope.row.title }}
                            </template>
                        </el-table-column>

                        <el-table-column prop="3" label="Дата создания" key="Дата" sortable="custom" minWidth="120px">
                            <template slot-scope="scope">
                                <i class="el-icon-time"></i>
                                <span style="margin-left: 10px">{{ scope.row.date }}</span>
                                <div v-if="scope.row.status === 1" :title="scope.row.time"><small>Дата постинга <b>{{ scope.row.time }}</b></small></div>
                            </template>
                        </el-table-column>

                        <el-table-column prop="5" label="Время выхода" sortable="custom">
                            <template slot-scope="scope">
                                <i class="el-icon-time"></i>
                                <span style="margin-left: 10px">{{ scope.row.timestart }} - {{ scope.row.timeend }}</span>
                                <div v-if="scope.row.day && scope.row.day !== '01.01.1970'">
                                    <i class="el-icon-date"></i>
                                    <span style="margin-left: 10px">{{ scope.row.day }}</span>  <span v-if="scope.row.dayto"> - {{ scope.row.dayto }}</span>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column prop="4" label="Статус" key="Статус" sortable="custom" minWidth="110px">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.status === 1" type="info">В ожидании</el-tag>
                                <el-tag v-if="scope.row.status === 2" type="success">Опубликована</el-tag>
                                <el-tag v-if="scope.row.status === 3" type="danger">Отклонена</el-tag>
                                <el-tag v-if="scope.row.status === 4" type="danger">Ошибка</el-tag>
                            </template>
                        </el-table-column>

                        <template slot="mobile-card" slot-scope="scope">
                            <div class="media">
                                <div class="media-body">
                                    <h4 class="media-heading wrap-text">{{ scope.row.name }} - {{ scope.row.title }}</h4>
                                    <p class="m-0"><i class="el-icon-time"></i> {{ scope.row.date }}</p>
                                </div>
                            </div>
                            <hr>
                            <div>
                                <el-tag v-if="scope.row.status === 1" type="warning">В ожидании</el-tag>
                                <el-tag v-if="scope.row.status === 2" type="success">Опубликована</el-tag>
                                <el-tag v-if="scope.row.status === 3" type="danger">Отклонена</el-tag>
                                <el-tag v-if="scope.row.status === 4" type="danger">Ошибка</el-tag>
                            </div>
                        </template>

                    </NativeTable>

                </div>
            </div>
        </section>

        <el-dialog title="Принять задачу" :visible.sync="acceptModal" width="30%">
            <p>Выберите подходящее время для публикации задачи</p>

            <div class="form-group mb-5">
                <label>Время публикации</label>
                <el-time-select v-model="value" :picker-options="{ start: editedRow.dateStart, step: '00:01', end: editedRow.dateEnd }" :placeholder="editedRow.date"></el-time-select>
            </div>

            <div>
                <el-button type="primary" @click="accept()">Подтвердить</el-button>
                <el-button @click="acceptModal = false">Закрыть</el-button>
            </div>

        </el-dialog>

    </div>
</template>

<script>
    export default {
        name: 'tasks',
        data() {
            return {
                acceptModal: false,
                editedRow: '',
                value: '',
                data: [{
                    id: '1',
                    group: 'Веселые мемесы',
                    task: 'Tom',
                    date: '17:30 12.02.2019',
                    status: 1
                }, {
                    id: '2',
                    group: 'Хот тималле',
                    task: 'Tom',
                    date: '17:30 12.02.2019',
                    status: 0
                }, {
                    id: '3',
                    group: 'Cardi B',
                    task: 'Tom',
                    date: '17:30 12.02.2019',
                    status: 2
                }, {
                    id: '4',
                    group: 'Lykke li',
                    task: 'Tom',
                    date: '17:30 12.02.2019',
                    status: 1
                }]
            }
        },
        methods: {
            acceptTask: function (row) {
                this.editedRow = row;
                this.value = row.dateStart;
                this.acceptModal = true;
            },
            accept: function () {
                this.data.forEach((item, i) => {
                    if (item.id == this.editedRow.id) this.data.splice(i, 1);
                });
                this.acceptModal = false;
            }
        },
        components: {

        }
    }
</script>

<style scoped>
    .el-tag {
        width: 100px;
        text-align: center;
    }
</style>
